
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.317 15.6a14.19 14.19 0 00-13.325-8.933A14.19 14.19 0 002.747 15.56c-.052.141-.079.29-.08.44-.001.142.026.282.08.413a14.19 14.19 0 0013.245 8.92 14.19 14.19 0 0013.245-8.893c.057-.14.084-.29.08-.44a1.22 1.22 0 000-.4zm-13.325 7.067A11.751 11.751 0 015.425 16a11.712 11.712 0 0110.567-6.664c4.51 0 8.62 2.592 10.567 6.664a11.753 11.753 0 01-10.567 6.667zm0-10.667c-2.208 0-3.998 1.79-3.998 4a3.998 3.998 0 107.995 0c0-2.21-1.79-4-3.997-4z"}})])
          )
        }
      }
    